import React from "react";
import Solicitudes from "../../components/2.5 espera/procesos";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
